import './App.css';
import Footer from './MainElements/Footer';
import Header from './MainElements/Header';
import MainPage from './Pages/MainPage';
import DevPage from './Pages/DevPage';
import ArtPage from './Pages/ArtPage';

import React, { useState } from 'react';
import AboutPage from './Pages/AboutPage';


function App() {

    const [currentPage, setCurrentPage] = useState('main');

    const setContentVisible = (visible) => {
        setTimeout(() => {
            const container = document.querySelector('.pageContainer');
            const header = document.querySelector('.headerContainer');
            if(visible){
                container.classList.remove('transparent');
                if(header){
                    header.classList.remove('transparent');
                }                
            }else{
                container.classList.add('transparent');
                if(header){
                    header.classList.add('transparent');
                }                
            }
        }, 25);        
    }

    const changePage = (destination) => {
        if(destination !== currentPage){        
            setContentVisible(false);
            setTimeout(() => {       
                document.querySelector('.headerContainer').classList.add('shifted');        
                if(window.scrollY > 150){
                    window.scrollTo({top: 150});
                }                
                setCurrentPage(destination);
            }, 700);        
        }
    }

    const renderContent = () => {        
        if(currentPage === 'main'){
            return(
                <>
                <MainPage
                    changePage={changePage}/>
                </>
            );
        }

        if(currentPage === 'dev'){
            return(
                <>
                    <DevPage/>
                </>
            );
        }

        if(currentPage === '2d' || currentPage === '3d'){
            return(
                <>
                    <ArtPage
                        artType={currentPage}/>
                </>
            );
        }

        // if(currentPage.includes('project_app')){
        //     return(
        //         <>
        //         <ProjectPage
        //             projectData={ getProjectData( currentPage.substring(12, currentPage.length) ) }/>
        //         </>
        //     );
        // }

        if(currentPage === 'about'){
            return(
                <>
                    <AboutPage/>
                </>
            )
        }
        
        
        return(
            <div className="notAvailableContainer">
                <h1>Sorry, content is not available yet.</h1>
                <p>Site is under development now. This page will be available soon. 
                    But you can find content at my ArtStation (2D and 3D Art and Products), 
                    Instagram (2D and 3D Art), old site (Games and Applications). 
                    All links are attached to the footer.</p>
                
                <p>Last update: 3 September 2021</p>
            </div>
        );   
    }


    window.scroll(0, 0);
    setContentVisible(true);
    return (
        <>        
            <Header
                changePage={changePage}
                isMainPage={currentPage === "main"}/>
                
            
            <div className="pageContainer transparent">
                
                
                <div className="contentContainer">          
                    
                    {renderContent()}
                        
                </div>
                <Footer/>
            </div>   
        </>
    );
}

export default App;
